import { MealLock } from '@/plugins/api'

/**
 * Store Khóa đăng ký. Có thể lọc theo meal_slot (các khóa của 1 bữa)
 * hoặc lấy toàn bộ (màn danh sách khóa).
 */
export default {
  namespaced: true,
  state: {
    locks: [],
    loading: false
  },
  actions: {
    async fetchList({ commit }, query = {}) {
      commit('changeState', { loading: true })
      const locks = await MealLock.fetch({ ...query, _limit: query._limit || -1 })
      commit('changeState', { locks, loading: false })
    },
    async fetchOne(_, id) {
      return MealLock.fetchOne(id)
    },
    async create(_, data) {
      return MealLock.create(data)
    },
    async update(_, { id, ...data }) {
      return MealLock.update(id, data)
    },
    async remove(_, id) {
      return MealLock.remove(id)
    }
  },
  mutations: {
    changeState(state, obj) {
      Object.assign(state, obj)
    }
  }
}
